import { getApiClient } from '../client';
import { handleApiError } from '../utils/handleApiError';
import type { ServiceResponse } from '@dopomogai/types';

export interface ConversationUsageLogItem {
  id: string;
  timestamp: string;
  model_name?: string | null;
  provider?: string | null;
  prompt_tokens: number;
  completion_tokens: number;
  total_tokens: number;

  // Provider cost and credits
  actual_provider_cost_usd: number;
  credits_charged: number;

  // Pricing snapshot + breakdown
  input_pricing_per_million_tokens?: number | null;
  output_pricing_per_million_tokens?: number | null;

  impact_pct?: number | null;
  margin_pct?: number | null;

  impact_usd?: number | null;
  margin_usd?: number | null;

  // Total user cost (provider + impact + margin)
  total_cost_usd?: number | null;

  purpose?: string | null;
  metadata?: Record<string, any>;
}

export interface ConversationUsageLogsResponse {
  conversation_id: string;
  total_cost_usd: number;
  total_credits_charged: number;
  total_tokens: number;
  items: ConversationUsageLogItem[];
}

export const conversationUsageService = {
  getConversationUsageLogs: (conversationId: string): ServiceResponse<ConversationUsageLogsResponse> => {
    return getApiClient()
      .get<ConversationUsageLogsResponse>(`/conversations/${conversationId}/usage-logs`)
      .then((r) => r.data)
      .catch((err) => handleApiError(err, 'fetching conversation usage logs'));
  },
};